<template>
  <div id="paginaProtocollo">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Genera protocollo per documenti</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropStagioni" ref="dropStagioni"
                  :query="queryStagioni" :dataSource="stagioniData"
                  :index="stagioniIndex" :fields="stagioniFields"
                  :change="onStagioneChange" v-model="stagioneCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid id="gridA" ref="gridA" :dataSource="protocolloFullData" :allowSorting="true"
                  :sortSettings="gridA.sortOptions" :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                  :height="gridA.height" :allowFiltering="true" :editSettings="gridA.editOptions" :filterSettings="gridA.filterOptions">
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="60"></e-column>
                    <e-column field="codice" headerText="Codice" width="100"></e-column>
                    <e-column field="data_utilizzo" headerText="Data Utilizzo" width="100" :format="settings.formatoData"
                      type="date"></e-column>
                    <e-column field="oggetto" headerText="Oggetto" width="100"></e-column>
                    <e-column field="documento" headerText="Documento" width="100"></e-column>
                    <e-column field="note" headerText="Note" width="100"></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-button id="downloadAnnoButton" cssClass="e-flat" @click.native="downloadXls()">Scarica Excel Protocolli Anno</ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
          <!-- inserire grid -->
        </b-card>
      </b-col>
    </b-row>
    <!-- dialogA: dialogDettaglioProtocollo ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA" ref="dialogA" :header="dialogA.header" :buttons="dialogA.buttons" :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon" :close="dialogAClose" :open="dialogAOpen" :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings" :isModal="dialogA.isModal">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Protocollo">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-3">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Protocollo</b-card-title>
                    <b-card-text class="mb-1" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-1">
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2" v-show="gridA.codice">
                      <label for="codice" class="h5">Codice</label>
                      <ejs-textbox id="codice" v-model="protocolloActiveData.codice" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" :readonly="true"/>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="anno" class="h4">Anno</label>
                      <ejs-textbox id="anno" v-model="protocolloActiveData.anno" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataUtilizzo" class="h4">Data utilizzo</label>
                      <ejs-datepicker id="dataUtilizzo" v-model="protocolloActiveData.data_utilizzo"
                        :format="settings.formatoDatepicker" :firstDayOfWeek="settings.firstDayOfWeek" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dropUtente" class="h4">Utente</label>
                      <ejs-dropdownlist id="dropUtente" ref="dropUtente"
                        :dataSource="utentiList" :fields="utentiFields"
                        v-model="protocolloActiveData.utente" :readonly="gridA.solalettura"
                        placeholder="Seleziona un utente"></ejs-dropdownlist>
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="oggetto" class="h5">Oggetto</label>
                      <ejs-textbox id="oggetto" v-model="protocolloActiveData.oggetto" floatLabelType="Never" cssClass=""
                        placeholder="Oggetto" showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="documento" class="h5">Documento Collegato</label>
                      <ejs-textbox id="documento" v-model="protocolloActiveData.documento" floatLabelType="Never" cssClass=""
                        placeholder="link al documento" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox id="note" v-model="protocolloActiveData.note" floatLabelType="Never" cssClass=""
                        placeholder="Note" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="cartaceo" class="h5">Cartaceo</label>
                      <ejs-textbox id="cartaceo" v-model="protocolloActiveData.cartaceo" floatLabelType="Never" cssClass=""
                        placeholder="Cartaceo" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  AlertPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  ButtonPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DatePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  DropDownListPlugin,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(AlertPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DropDownListPlugin);
enableRipple(true);
// api

const apiProtocolloUrl = "/demo/api/protocollo";
const apiProtocolloExportXlsUrl = "/demo/api/protocollo/export_xls";
const apiProtocolloRicercaUrl = "/demo/api/protocollo/ricerca";

export default Vue.extend({
  components: {},
  data() {
    return {
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },

      utentiList: [
          { label: "Helenio Talato", val: "HA" },
          { label: "Giulia Fregosi", val: "GF" },
          { label: "Corinne Baroni", val: "CB" },
          { label: "Giulia Annovati", val: "GA" },
          { label: "Serena Galasso", val: "SG" },
          { label: "Elena Montorsi", val: "EM" },
          { label: "Massimo Bellini", val: "MB" },
          { label: "Michela Caretti", val: "MC" },
          { label: "Shaindel Novoa", val: "SN" },
          { label: "Ilaria Caputo", val: "IC" },
          { label: "Michele Annichiarico", val: "MA" },
          { label: "Cristiano Busatto", val: "CB" },
          { label: "Ivan Pastrovicchio", val: "IP" },
          { label: "Alessandro Raimondi", val: "AR" },
          { label: "Silvia Lumes", val: "SL" },
          { label: "Daniele Capris", val: "DC" },
      ],
      utentiFields: { value: "val", text: "label" },
      // stagioni
      stagioniData: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      stagioniFields: { value: "val", text: "label" },
      stagioniIndex: -1,
      queryStagioni: null,
      stagioneCorrente: "2025",
      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,
      // per gridA
      gridA: {
        codice: false,
        solalettura: false,
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo Protocollo", tooltipText: "Crea nuovo Protocollo", prefixIcon: "e-plus", id: "new",
          },
          {
            text: "Modifica Protocollo", tooltipText: "Modifica Protocollo", prefixIcon: "e-expand", id: "edit",
          },
          {
            text: 'Cancella', tooltipText: 'Cancella Cedolino', prefixIcon: 'e-delete', id: 'delete',
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "dataCreazione", direction: "Ascending" }] },
      },
      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 },
        zIndex: 1050,
        isModal: false,
        tabAdialogAIndex: 0,
      },
      protocolloFullData: [], // elenco completo dati protocollo
      protocolloActiveData: {}, // dati del protocollo corrente
      protocolloActiveId: 0,
    };
  },
  created() {
    console.log("Pagina Protocollo Creata");
    const datiDaInviare = {'anno': this.stagioneCorrente};
    useJwt.post(apiProtocolloRicercaUrl, datiDaInviare).then((d) => {
      this.protocolloFullData = d.data;
    })
  },
  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit],
  },

  methods: {
    onStagioneChange: function (e) {
      console.log("Change")
      console.log("Recupero elenco protocolli dal backend per l'anno selezionato");
      const datiDaInviare = {'anno': this.stagioneCorrente};
      useJwt.post(apiProtocolloRicercaUrl, datiDaInviare).then((d) => {
        this.protocolloFullData = d.data;
      })
    },
    downloadXls: function() {
      let datiDaInviare = {anno: this.stagioneCorrente}

      useJwt.post(apiProtocolloExportXlsUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore stagione non selezionata")
      });
    },

    async dialogAOk() {
      let error = false
      let messaggio = ""
      // distinguere tra new ed edit
      if (this.protocolloActiveId === 0) {
        error = await useJwt.post(apiProtocolloUrl, this.protocolloActiveData).then((d) => {
          console.log("protocollo generato")
          console.log(d.data);
          messaggio = `Protcollo ${d.data['codice']} creato correttamente`
          return this; // restituisci contesto per permettere aggiornamento grid
        }).then((context) => {
          useJwt.post(apiProtocolloRicercaUrl, { 'anno': this.stagioneCorrente }).then((d) => {
            console.log("Aggiornamento grid")
            context.protocolloFullData = d.data;
            context.protocolloFullData = [...context.protocolloFullData];
          })
        }).catch(error => {
            if (error.response) {
              if ((error.response.status) && (error.response.status == 404)) {
                messaggio = "ERRORE interno applicativo (pagina non trovata)"
              } else {
                if (error.response.data) {
                  console.log(error.response.data)
                  let chiavi = Object.keys(error.response.data)
                  chiavi.forEach((k) => {
                    messaggio += `${k}: ${error.response.data[k]}`
                    messaggio += "\n"
                  })
                } else {
                  messaggio = "Errore: Protocollo non creato"
                }
              }
            }
            this.makeToast("primary", "ERRORE", messaggio)
            return true
        })
      } else {
        // edit
        // salvataggio in caso di edit
        const editUrl = `${apiProtocolloUrl}/${this.protocolloActiveId}`;
        error = await useJwt.patch(editUrl, this.protocolloActiveData).then((d) => {
          console.log("protocollo salvato")
          console.log(d.data);
          messaggio = `Protcollo ${d.data['codice']} salvato correttamente`
          return this; // restituisci contesto per permettere aggiornamento grid
        }).then((context) => {
          useJwt.post(apiProtocolloRicercaUrl, { 'anno': this.stagioneCorrente }).then((d) => {
            console.log("Aggiornamento grid")
            context.protocolloFullData = d.data;
            context.protocolloFullData = [...context.protocolloFullData];
          })
        }).catch(error => {
            if (error.response) {
              if ((error.response.status) && (error.response.status == 404)) {
                messaggio = "ERRORE interno applicativo (pagina non trovata)"
              } else {
                if (error.response.data) {
                  console.log(error.response.data)
                  let chiavi = Object.keys(error.response.data)
                  chiavi.forEach((k) => {
                    messaggio += `${k}: ${error.response.data[k]}`
                    messaggio += "\n"
                  })
                } else {
                  messaggio = "Errore: Protocollo non creato"
                }
              }
            }
            this.makeToast("primary", "ERRORE", messaggio)
            return true
        })
      }

      if (!error) {
        this.makeToast("primary", "Successo", messaggio)
        this.$refs.dialogA.hide();
      }
    },

    gridAClickHandler(args) {
      if (args.item.id === "new") {
        const today = new Date()
        // altro da fare
        // protocollodefaultdata da settare
        this.protocolloActiveData = {
            anno: today.getFullYear(),
            data_utilizzo: today,
            utente: null,
            oggetto: null,
            documento: null,
            note: null,
            cartaceo: null,
        }
        this.protocolloActiveId = 0
        this.gridA.codice = false
        this.gridA.solalettura = false
        this.$refs.dialogA.show(true)
      } else if (args.item.id === "edit") {
        const selectedRow = this.$refs.gridA.getSelectedRecords()
        this.protocolloActiveData = selectedRow[0]
        this.protocolloActiveId = selectedRow[0].id

        console.log("protocollo SELEZIONATO")
        console.log(selectedRow[0])
        this.gridA.codice = true
        this.gridA.solalettura = true
        this.$refs.dialogA.show(true)
      } else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina protocollo");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;
          this.$refs.gridA.ej2Instances.deleteRecord();

          const deleteUrl = `${apiProtocolloUrl}/${deletedElementId}`;

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });

        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }

    },

    dialogAOpen(args) {
    },
    dialogAClose(args) {
    },

    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
